import {
  ToggleBlockType
} from './block-type'

export class BlockQuote extends ToggleBlockType {
  getBlockType = () => 'blockquote'

  getButtonText = () => 'BQ'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/block-quote.js
 **/